export const YEARLY_REVENUE_MOCK = [
  {
    name: 'January',
    revenue: 1000,
    mrr: 600,
  },
  {
    name: 'February',
    revenue: 1200,
    mrr: 690,
  },
  {
    name: 'March',
    revenue: 1300,
    mrr: 780,
  },
  {
    name: 'April',
    revenue: 1500,
    mrr: 900,
  },
  {
    name: 'May',
    revenue: 1900,
    mrr: 950,
  },
  {
    name: 'June',
    revenue: 2100,
    mrr: 1170,
  },
  {
    name: 'July',
    revenue: 2300,
    mrr: 1300,
  },
  {
    name: 'August',
    revenue: 2500,
    revenue_forecast: 2500,
    mrr: 1500,
    mrr_forecast: 1500,
  },
  {
    name: 'September',
    revenue_forecast: 2700,
    mrr_forecast: 1700,
  },
  {
    name: 'October',
    revenue_forecast: 2900,
    mrr_forecast: 1900,
  },
  {
    name: 'November',
    revenue_forecast: 3100,
    mrr_forecast: 2100,
  },
  {
    name: 'December',
    revenue_forecast: 3300,
    mrr_forecast: 2300,
  },
];

export const COFFEE_USAGE_AVG_MOCK = [
  {
    name: 'January',
    revenue: 210,
  },
  {
    name: 'February',
    revenue: 215,
  },
  {
    name: 'March',
    revenue: 280,
  },
  {
    name: 'April',
    revenue: 265,
  },
  {
    name: 'May',
    revenue: 320,
  },
  {
    name: 'June',
    revenue: 321,
  },
  {
    name: 'July',
    revenue: 342,
  },
  {
    name: 'August',
    revenue: 341,
    revenue_forecast: 341,
  },
  {
    name: 'September',
    revenue_forecast: 350,
  },
  {
    name: 'October',
    revenue_forecast: 360,
  },
  {
    name: 'November',
    revenue_forecast: 370,
  },
  {
    name: 'December',
    revenue_forecast: 380,
  },
];

export const OPERATING_HOURS_MOCK = [
  {
    name: 'January',
    hours: 100,
  },
  {
    name: 'February',
    hours: 121,
  },
  {
    name: 'March',
    hours: 130,
  },
  {
    name: 'April',
    hours: 153,
  },
  {
    name: 'May',
    hours: 192,
  },
  {
    name: 'June',
    hours: 210,
  },
  {
    name: 'July',
    hours: 230,
  },
  {
    name: 'August',
    hours: 250,
  },
  {
    name: 'September',
    hours: 264,
    hours_forecast: 264,
  },
  {
    name: 'October',
    hours_forecast: 285,
  },
  {
    name: 'November',
    hours_forecast: 301,
  },
  {
    name: 'December',
    hours_forecast: 322,
  },
];
